import { pluralForm } from "@utils";
import { sendMetric, getWhatId } from "@utils";
import { inject, observer } from "mobx-react";
import { useState, useRef, useEffect, useCallback } from "react";
import Confetti from "react-confetti";
const { VITE_WHAT_ID } = import.meta.env;

import pointerImg from "./img/pointer2.png";
import "./style.scss";

const Wheel = inject("mainStore")(
    observer(({ mainStore }) => {
        const setting = mainStore.getMainStore("settingLego");
        const wdCd = mainStore.getMainStore("codeTypeMetrika");
        const abTestMetika = mainStore.getMainStore("abTestMetika");

        const wheelRef = useRef(null);
        const [rotation, setRotation] = useState(22);
        const [seconds, setSeconds] = useState(setting.queueDuration);
        const [isSpinning, setIsSpinning] = useState(false);
        const [result, setResult] = useState(null);
        const [animationPhase, setAnimationPhase] = useState("idle");
        const offersList = mainStore.getMainStore("offersList");
        const ctaColor = setting?.ctaColor === "palette" ? "var(--color7)" : "#19b677";
        const what_id = getWhatId() ? getWhatId() : VITE_WHAT_ID;

        const isRandom = setting && setting.queueRandomness ? setting.queueRandomness : false;

        const segmentsRandom = [
            offersList?.offers.length - 4,
            offersList?.offers.length - 8,
            offersList?.offers.length - 2,
            offersList?.offers.length - 10,
            offersList?.offers.length - 7,
            offersList?.offers.length,
            offersList?.offers.length - 9,
            offersList?.offers.length - 5,
        ];

        const segments = [
            offersList?.offers.length - 5,
            offersList?.offers.length - 4,
            offersList?.offers.length - 3,
            offersList?.offers.length - 2,
            offersList?.offers.length - 1,
            offersList?.offers.length,
            offersList?.offers.length - 7,
            offersList?.offers.length - 6,
        ];

        // Находим максимальное значение и его индекс
        const maxValue = (isRandom ? segmentsRandom : segments).reduce((a, b) => (a > b ? a : b));
        const maxIndex = (isRandom ? segmentsRandom : segments).indexOf(maxValue);

        const spinWheel = useCallback(() => {
            if (isSpinning) return;

            setIsSpinning(true);
            setResult(null);
            setAnimationPhase("spinning");

            // Всегда останавливаемся на максимальном значении
            const targetSegment = maxIndex + 2;
            const segmentAngle = 360 / (isRandom ? segmentsRandom : segments).length;

            // Основное вращение: 5 полных оборотов (1800 градусов)
            const fullRotation = 360 * 5;

            // Угол середины целевого сегмента (с максимальным значением)
            const targetSegmentMidAngle = targetSegment * segmentAngle + segmentAngle / 2;

            // Откат назад на 3 сектора (135 градусов)
            const bounceBackAngle = segmentAngle * 3;

            // Финальная позиция с учетом отката
            const finalRotation = fullRotation + targetSegmentMidAngle - bounceBackAngle;

            // Начинаем вращение (без отката)
            setRotation(fullRotation + targetSegmentMidAngle);

            // Через 4 секунды начинаем откат
            setTimeout(
                () => {
                    setAnimationPhase("bouncing");
                    setRotation(finalRotation);

                    // Через 1 секунду завершаем
                    setTimeout(
                        () => {
                            setIsSpinning(false);
                            setAnimationPhase("idle");
                            setResult((isRandom ? segmentsRandom : segments)[targetSegment - 2]);

                            // Сохраняем конечное положение (нормализуем угол)
                            const normalizedRotation = finalRotation % 360;
                            setRotation(normalizedRotation);
                            sendMetric(`widget_step_2_show`, {
                                params1: [`ris_promo`],
                                params2: null,
                                params3: null,
                                params4: null,
                                params6: null,
                                params7: wdCd,
                                params8: what_id,
                            });
                            window.risMetrika.reachgoal_ch({
                                event: "widget_step_2_show",
                                siteId: what_id, //'id витрины',
                                session_uuid: localStorage.getItem("_r_p_s"),
                                widget_code: wdCd ? wdCd : "",
                            });
                        },
                        setting.queueDuration * 1000 * 0.6 - 1000,
                    );
                },
                setting.queueDuration * 1000 * 0.6 - 1000,
            );
        }, []);

        useEffect(() => {
            if (!result) {
                setTimeout(() => {
                    spinWheel();
                }, 1000);
            }
        }, [spinWheel, result]);

        useEffect(() => {
            const intervalSeconds = setInterval(() => {
                setSeconds((prev) => (prev > 0 ? prev - 1 : 1));
            }, 1000);

            return () => {
                clearInterval(intervalSeconds);
            };
        }, []);

        // Цвета для двухцветного колеса
        const getSegmentColor = (index) => {
            return index % 2 ? "" : ".4";
        };

        const handleClick = (isMetrika = false) => {
            if (isMetrika) {
                if (window.risMetrika && typeof window.risMetrika.reachgoal_ch === "function") {
                    window.risMetrika.reachgoal_ch({
                        event: "widget_step_2_click",
                        siteId: what_id,
                        session_uuid: localStorage.getItem("_r_p_s"),
                        widget_code: wdCd ? wdCd : "",
                    });
                }
                sendMetric(`click_wheel_ok`, {
                    params1: [`${abTestMetika ? abTestMetika : "ris_promo"}`],
                    params2: null,
                    params3: null,
                    params4: null,
                    params6: null,
                    params7: wdCd,
                    params8: what_id,
                });
            }
            mainStore.setMainStore("isStart", false);
            mainStore.setMainStore("isCoverRoot", false);
            mainStore.setMainStore("modal", false);
        };

        return (
            <div className="wheel-container">
                <div className="wheel-wrapper">
                    <div
                        ref={wheelRef}
                        className="wheel"
                        style={{
                            transform: `rotate(${rotation}deg)`,
                            transition: animationPhase === "spinning" ? `transform ${setting.queueDuration * 0.6 - 1}s ease` : animationPhase === "bouncing" ? `"transform ${1}s ease"` : "none",
                        }}
                    >
                        {(isRandom ? segmentsRandom : segments).map((value, index) => {
                            const segmentAngle = 360 / 8;
                            const angle = index * segmentAngle;

                            return (
                                <div
                                    key={index}
                                    className={`segment ${result ? (result === value ? "winner" : "lost") : ""}`}
                                    style={{
                                        transform: `rotate(${angle}deg)`,
                                        backgroundColor: "var(--color1)",
                                        zIndex: index,
                                        opacity: getSegmentColor(index),
                                    }}
                                >
                                    <div className="segment-content">
                                        <span className="segment-value">{value}</span>
                                    </div>
                                </div>
                            );
                        })}

                        {/* Центральный круг */}
                        <div className="wheel-center">
                            <div className="wheel-center-inner"></div>
                        </div>

                        {/* Декоративные разделители */}
                        <div className="wheel-dividers">
                            {(isRandom ? segmentsRandom : segments).map((_, index) => {
                                const angle = index * (360 / 8);
                                return (
                                    <div
                                        key={index}
                                        className="divider"
                                        style={{
                                            transform: `rotate(${angle}deg)`,
                                        }}
                                    ></div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Указатель */}
                    <div className="pointer">
                        <svg width="54" height="44" viewBox="0 0 54 44" xmlns="http://www.w3.org/2000/svg" style={{ transform: "rotate(180deg)" }}>
                            <polygon points="27,6 48,38 6,38" fill="#FF1493" stroke="#FF69B4" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" />
                        </svg>
                        {/* <img src={pointerImg} /> */}
                    </div>

                    {/* текст в центре круга  */}
                    <div className="wheel-center-text">{result ? "Ура!" : "?"}</div>
                </div>

                <div className="wheel-text">
                    <span className="title">{!result ? "Еще чуть-чуть! 🎁" : "Ваши подарки готовы! 🎁"}</span>
                    <span className="desc">
                        {!result ? (
                            "Определяем количество подарков"
                        ) : (
                            <>
                                У вас есть <span>5 минут</span> на выбор
                            </>
                        )}
                    </span>
                </div>

                {result && <Confetti className="animation-fortune__confetti" />}

                <div className="wheel-button">
                    {!result ? (
                        <div className="wheel-button__timer">
                            <span className="wheel-button__timer-text">
                                Подарки будут доступны через {seconds} секунд{pluralForm(seconds, ["у", "ы", ""])}
                            </span>
                            <div className="animation__progress_new" style={{ "--countAnimation": `${setting.queueDuration}s` }}></div>
                        </div>
                    ) : (
                        <div
                            className="wheel-button__btn"
                            style={{ backgroundColor: ctaColor }}
                            onClick={() => {
                                handleClick(true);
                            }}
                        >
                            Выбрать подарок
                        </div>
                    )}
                </div>
            </div>
        );
    }),
);

export default Wheel;
